import React, {useContext, useEffect, useState} from "react";
import {Trans, useTranslation} from "react-i18next";
import BasePage from "../../components/BasePage/BasePage";
import {callAPI} from "../../utils/utils";
import AccountsOverviewElement from "./AccountsOverviewElement";
import AccountAddPopup from "./AccountAddPopup";
import MenuButton from "../../components/MenuButton/MenuButton";
import PopupContext from "../../components/Popup/PopupContext";

const AccountsOverview = (props) =>  {
  const [t] = useTranslation();
  const [accountsData, setAccountsData] = useState([]);
  const {setPopupContent} = useContext(PopupContext);

  useEffect(() => {
    refreshAccounts();
  }, []);

  const refreshAccounts = () => {
    callAPI("account", "POST", "list").then(result => {
      if (result && 'accounts' in result && result.accounts)
        setAccountsData(result.accounts);
    });
  }
  window.refreshAccounts = refreshAccounts;

  const addAccount = (version) => {

    if (version === 'agency') {
      callAPI("account", "POST", "create").then(result => {
        refreshAccounts();
      });
    }

    if (version === 'free') {
      window.location.replace('https://de.page4.com/customer/create/');
    }

    if (version === 'retail') {
      window.location.replace('https://de.page4.com/customer/upgrade/');
    }
  }

  const accountsHtml = accountsData.map((account, index) => {
    return <AccountsOverviewElement account={account} key={index}/>
  });

  return (
    <BasePage title={t('Accounts.Overview.Title')} className={'accounts'}>
      <div>
        <Trans>Accounts.Overview.Title</Trans>
        <div className={'overview'}>
          {accountsHtml}
        </div>
        <div className={'simple-button'} onClick={() => setPopupContent(<AccountAddPopup onConfirm={(version) => {addAccount(version)}}/>)}>
          <Trans>Accounts.Overview.AddButton</Trans>
        </div>
      </div>
      <MenuButton/>
    </BasePage>
  );
}

export default AccountsOverview;